import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MediaclipService } from 'app/services/mediaclip.service';

@Component({
	selector: 'playout-details-behaviour',
	templateUrl: './playout-details-behaviour.component.html',
	styleUrls: ['./playout-details-behaviour.component.scss']
})

export class PlayoutDetailsBehaviourComponent implements OnInit, OnDestroy {

	@Input() playout: any;
	@Input() form: NgForm;
	@Input() formGroup: UntypedFormGroup;

	cmpTimeoutFormControl = new UntypedFormControl('', [Validators.min(0)]);
	minWidthUnits = [{ label: 'px', value: 'px' }];
	mediaclipOptions: any[];

	constructor(
		private mediaclipService: MediaclipService,
	) {
		this.mediaclipOptions = this.mediaclipService.getPropertyOptions().filter(property => (property.itype === 'string' || property.itype === 'text' ||
			property.itype === 'richtext') || property.value === 'title' || property.value === 'description');
	}

	ngOnInit() {
		this.formGroup.addControl('cmpTimeout', this.cmpTimeoutFormControl);
	}

	ngOnDestroy() {
	}

	log(a: any) {
		console.warn('log', a);
	}
}
